import { US_STATES } from '@mdvip/shared/lib/us-states';

/**
 * US state/territory codes offered in the address "State" dropdowns — the same shared 51-entry
 * list (50 states + DC) the payments billing-address form already uses, re-exported under this
 * module's own name for the type-narrowing below, which nothing else in `packages/shared` needs
 * yet (payments validates `state` as free text, not a closed set — see `paymentAccount.schema.ts`).
 */
export const US_STATE_CODES = US_STATES;

export type UsStateCode = (typeof US_STATE_CODES)[number];

/**
 * Narrows a free-text value (Salesforce's `MailingState`/`OtherState` predate this dropdown and
 * carry no format guarantee) to the closed set the dropdowns offer. A value outside the list
 * seeds blank rather than crashing the form or rendering a value the dropdown has no option for —
 * same fallback shape as `isSalutation`.
 */
export function isUsStateCode(value: string): value is UsStateCode {
  return (US_STATE_CODES as readonly string[]).includes(value);
}
